import { useState } from 'react'

import { useGetFixSessionMessages } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError/index.tsx'

import { Card } from '@/components/card'
import { Switch } from '@/components/switch'

import { cn } from '@/utils/cn.ts'

import OrderMessageTable from './orderMessageTable.tsx'
import RawMessageTable from './rawMessageTable.tsx'

interface Props {
    clientCode: string
    sessionId: string
}

export default function FixSesssionMessageTable({ clientCode, sessionId }: Props) {
    // TODO - add pagination (Issue #206)
    const { data: messages } = useGetFixSessionMessages(
        clientCode,
        sessionId,
        { Limit: 500 },
        { query: { suspense: true, refetchInterval: 1000 } },
    )
    const [orderView, setOrderView] = useState(false)

    if (!messages?.data) {
        return <UnexpectedDataStateError />
    }

    const textClasses = 'text-sm border-b border-transparent cursor-pointer hover:border-primary'

    return (
        <Card hideOverflow>
            <div className="flex items-center justify-end p-4 bg-secondary">
                <span
                    className={cn(textClasses, {
                        'border-primary': !orderView,
                    })}
                    onClick={() => setOrderView(false)}
                >
                    Message view
                </span>
                <Switch checked={orderView} onCheckedChange={setOrderView} className="mx-2" />
                <span
                    className={cn(textClasses, {
                        'border-primary': orderView,
                    })}
                    onClick={() => setOrderView(true)}
                >
                    Order view
                </span>
            </div>
            {orderView ? <OrderMessageTable messages={messages.data} /> : <RawMessageTable messages={messages.data} />}
        </Card>
    )
}
